export default __webpack_public_path__ + "94f98197ddad31ca78bee1ebfc216f1d.png";